module.exports = __webpack_public_path__ + "static/media/botswana-flag-round-small.39819b52.jpg";